import React, { FC, memo } from 'react';
import { DivInnerFields, DivTitle } from '../../../styles';
import { Field } from 'formik';
import { COLORGATE_CONFIGURATION_TITLES, ColorgateConfigurationFields, WhiteOptionValues } from '../../../constants';
import DropdownField from '../../FormComponents/DropdownFiled';
import { TColorgateConfigurationOptions } from '../../../types';
import clsx from 'clsx';
import NumberFormatField from '../../FormComponents/NumberFormatField';

type TProps = {
  options: TColorgateConfigurationOptions;
  values: any;
};

const SpecialColorBlock: FC<TProps> = ({ options, values }) => {
  return (
    <>
      <DivTitle>Special colors</DivTitle>
      <Field name={ColorgateConfigurationFields.SpecialColorsWhite}>
        {({ field, form }) => (
          <DropdownField
            name={field.name}
            options={options[ColorgateConfigurationFields.SpecialColorsWhite]}
            title={COLORGATE_CONFIGURATION_TITLES.specialColorsWhite}
            value={field.value}
            setFieldValue={form.setFieldValue}
          />
        )}
      </Field>
      <DivInnerFields
        className={clsx({
          ['hidden']: values[ColorgateConfigurationFields.SpecialColorsWhite] === 'Off'
        })}
      >
        <Field name={ColorgateConfigurationFields.WhiteMinimum}>
          {({ field, form }) => (
            <NumberFormatField
              name={field.name}
              title={COLORGATE_CONFIGURATION_TITLES.whiteMinimum}
              placeholder="Enter number"
              value={field.value}
              setFieldValue={form.setFieldValue}
            />
          )}
        </Field>
        <div className="inner-fields-row">
          <div>
            <Field name={ColorgateConfigurationFields.WhiteLimit}>
              {({ field, form }) => (
                <NumberFormatField
                  name={field.name}
                  title={COLORGATE_CONFIGURATION_TITLES.whiteLimit}
                  placeholder="Enter number"
                  value={field.value}
                  setFieldValue={form.setFieldValue}
                />
              )}
            </Field>
            <Field name={ColorgateConfigurationFields.WhiteIntensity}>
              {({ field, form }) => (
                <NumberFormatField
                  name={field.name}
                  title={COLORGATE_CONFIGURATION_TITLES.whiteIntensity}
                  placeholder="Enter number"
                  value={field.value}
                  setFieldValue={form.setFieldValue}
                />
              )}
            </Field>
          </div>
          <div>
            <Field name={ColorgateConfigurationFields.WhiteSpreadChoke}>
              {({ field, form }) => (
                <NumberFormatField
                  name={field.name}
                  title={COLORGATE_CONFIGURATION_TITLES.whiteSpreadChoke}
                  placeholder="Enter number"
                  value={field.value}
                  setFieldValue={form.setFieldValue}
                  allowNegative={true}
                />
              )}
            </Field>
            <Field name={ColorgateConfigurationFields.WhiteEdges}>
              {({ field, form }) => (
                <DropdownField
                  name={field.name}
                  options={options[ColorgateConfigurationFields.WhiteEdges]}
                  title={COLORGATE_CONFIGURATION_TITLES.whiteEdges}
                  value={field.value}
                  setFieldValue={form.setFieldValue}
                />
              )}
            </Field>
          </div>
        </div>
      </DivInnerFields>
      <Field name={ColorgateConfigurationFields.SpecialColorsWhite2}>
        {({ field, form }) => (
          <DropdownField
            name={field.name}
            options={options[ColorgateConfigurationFields.SpecialColorsWhite2]}
            title={COLORGATE_CONFIGURATION_TITLES.specialColorsWhite2}
            value={WhiteOptionValues.Off}
            setFieldValue={form.setFieldValue}
            disabled={true}
          />
        )}
      </Field>
    </>
  );
};

export default memo(SpecialColorBlock);
